/*
 * File: InputDate.js
 * Project: mp-mobile-app
 *
 * Created by jeddumire on 09/19/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Input control for entering a date combined with a time
 */
import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { KeyboardDateTimePicker } from "@material-ui/pickers";

const InputDateTime = ({ field, value, error, dateOnChange, parentOnBlur }) => {
  if (value === "") {
    value = null;
  }
  return (
    <KeyboardDateTimePicker
      error={error}
      onChange={dateOnChange}
      onBlur={parentOnBlur}
      key={field.name}
      id={field.name}
      name={field.name}
      inputVariant="filled"
      value={value}
      label={field.label}
      format={"MM/dd/yyyy hh:mm a"}
    />
  );
};

InputDateTime.propTypes = {
  field: PropTypes.object.isRequired,
  value: PropTypes.instanceOf(Date),
  error: PropTypes.bool,
  dateOnChange: PropTypes.func.isRequired,
  parentOnBlur: PropTypes.func
};

export default observer(InputDateTime);
